function equalHeight() {
   $.fn.extend({
      equalHeights: function () {
         var e = 0,
            t = ("equalHeights" + Math.random()).replace(".", "");
         $(this).each(function () {
            var a = $(this).offset().top;
            a > e && ($("." + t).removeClass(t), e = a), $(this).addClass(t), $(this).height("auto");
            var i = Math.max.apply(null, $("." + t).map(function () {
               return $(this).outerHeight()
            }).get());
            $("." + t).outerHeight(i)
         }).removeClass(t)
      }
   }), $(".equalHeights").equalHeights()
}
$(window).on("load", function () {
   equalHeight()
}), $(window).resize(function () {
   equalHeight()
});

// For home review section
function equalHeight1() {
    $.fn.extend({
        equalHeights: function () {
            var top = 0;
            var row = [];
            var classname = ("equalHeights" + Math.random()).replace(".", "");
            $(this)
                .each(function () {
                    var thistop = $(this).offset().top;
                    if (thistop > top) {
                        $("." + classname).removeClass(classname);
                        top = thistop;
                    }
                    $(this).addClass(classname);
                    $(this).height("auto");
                    var h = Math.max.apply(
                        null,
                        $("." + classname)
                        .map(function () {
                            return $(this).outerHeight();
                        })
                        .get()
                    );
                    $("." + classname).outerHeight(h);
                })
                .removeClass(classname);
        }
    });
    $(".reviews .jdgm-carousel-item").equalHeights(); 
}

$(document).ready(function () { 
	 setTimeout(function () {
        equalHeight1();
    }, 500); 
});
$(window).on("load", function () {
	setTimeout(function () {
        equalHeight1();
    }, 500);
	
});
$(window).resize(function () {
	equalHeight1();
});

document.addEventListener('DOMContentLoaded',function() {
	setTimeout(function(){
		document.querySelectorAll('.custom-grid-product').forEach(el => {
			var btn = el.querySelector('.featured_cart_btn');
			var variantId = btn.dataset.variantId;
			btn.setAttribute("onclick", "add_to_cart_grid("+variantId+",1)");

			var url = el.querySelector('.grid-product__link');
			var variantUrl = url.dataset.variantUrl;
			url.setAttribute("href", variantUrl);

			var price = el.querySelector('.custom-price');
			var variantPrice = price.dataset.variantPrice;
			price.setHTML(variantPrice);
		});
	}, 2000);
});


function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    var thisObject = this;
     setTimeout(function(){ 
      const poster = thisObject.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', thisObject.loadContent.bind(thisObject));
    }, 1000);
  }

  loadContent(focus = true) {
    console.log('loadcontent');
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

